import { Link } from "react-router-dom";
import AdminSidebar from "../components/AdminSidebar";
import "../css/admin.css";

function WebsiteManagement() {
  return (
    <div className="admin-layout">

      <AdminSidebar />

      <div className="admin-content">

        <h1>Website Management</h1>

        <div className="dashboard-grid">

          {/* Hero Banner */}
          <Link className="dashboard-card" to="/admin/hero-banner">
            <h2>Hero Banner</h2>
            <p>Manage homepage banners</p>
          </Link>

          {/* Announcement Bar */}
          <Link className="dashboard-card" to="/admin/announcement">
            <h2>Announcement Bar</h2>
            <p>Manage announcements</p>
          </Link>

          {/* Flash Sale */}
          <Link className="dashboard-card" to="/admin/flash-sale">
            <h2>Flash Sale</h2>
            <p>Manage flash sale products</p>
          </Link>

          {/* Categories */}
          <Link className="dashboard-card" to="/admin/categories">
            <h2>Categories</h2>
            <p>Add, Edit & Delete Categories</p>
          </Link>

          {/* New Arrivals */}
          <Link className="dashboard-card" to="/admin/new-arrivals">
            <h2>New Arrivals</h2>
            <p>Manage New Arrival Products</p>
          </Link>

          {/* Featured Products */}
          <Link className="dashboard-card" to="/admin/featured-products">
            <h2>Featured Products</h2>
            <p>Manage Featured Products</p>
          </Link>

          {/* Why Choose Us */}
          <Link className="dashboard-card" to="/admin/why-choose-us">
            <h2>Why Choose Us</h2>
            <p>Manage Homepage Features</p>
          </Link>

          {/* Footer */}
          <Link className="dashboard-card" to="/admin/footer">
            <h2>Footer Management</h2>
            <p>Edit Footer Links & Contact Information</p>
          </Link>

        </div>

      </div>

    </div>
  );
}

export default WebsiteManagement;